import { SendErrorLog } from "./GlobalUtility";
import { previewImage, previewImageFile } from "./ImageUtility";
import { loadingStore } from "./LoadingStore";
import { fetchCustomMarker, isPOIModalSimpleOpen, isPOIModalSimpleOpen2 } from "./MapSetting";
import { showNotification } from "./Notification";
import { GET_SERVER_REQUEST, poi_list, SERVER_REQUEST } from "./ServerConnect";

export const savePOI = async (markerName, markerDescription, latitude, longitude, isAddCustomMarker, markerId) => {
  try {
    if (!markerName || !latitude || !longitude) {
      showNotification('Enter information.', 'warn', 'top-center');
      return;
    }

    let upload_image = previewImage.value;
    if (previewImage.value === new URL('../assets/images/logo.png', import.meta.url).href)
    {
      upload_image = null;
    } else {
      upload_image = previewImageFile.value
    }

    const formData = new FormData();
    if (!isAddCustomMarker) formData.append("marker_id", markerId);
    formData.append("title", markerName);
    formData.append("description", markerDescription);
    formData.append("marker_image", upload_image);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);

    loadingStore.showLoading();
    await SERVER_REQUEST('marker', isAddCustomMarker ? 'POST' : 'PUT', formData, false, null);

    fetchCustomMarker();
  } catch (error) {
    SendErrorLog('POI', error);
  } finally {
    loadingStore.hideLoading();
  }
  if (isPOIModalSimpleOpen.value) isPOIModalSimpleOpen.value = false;
  if (isPOIModalSimpleOpen2.value) isPOIModalSimpleOpen2.value = false;
  await fetchPOIData();
}

export const deletePOI = async (id) => {
  try {
    const totalData = {
      marker_id: id
    }
    const jsonData = JSON.stringify(totalData);

    loadingStore.showLoading();
    await SERVER_REQUEST('marker', 'DELETE', jsonData);
  } catch (error) {
    SendErrorLog('POI', error);
  } finally {
    loadingStore.hideLoading();
  }
  if (isPOIModalSimpleOpen.value) isPOIModalSimpleOpen.value = false;
  if (isPOIModalSimpleOpen2.value) isPOIModalSimpleOpen2.value = false;
  await fetchPOIData();
}

export const restorePOI = async (id) => {
  try {
    const totalData = {
      marker_id: id,
      undelete: true
    }
    const jsonData = JSON.stringify(totalData);

    loadingStore.showLoading();
    await SERVER_REQUEST('marker', 'DELETE', jsonData);
  } catch (error) {
    SendErrorLog('POI', error);
  } finally {
    loadingStore.hideLoading();
  }
  if (isPOIModalSimpleOpen.value) isPOIModalSimpleOpen.value = false;
  if (isPOIModalSimpleOpen2.value) isPOIModalSimpleOpen2.value = false;
  await fetchPOIData();
}

export const fetchPOIData = async () => {
  poi_list.value = await GET_SERVER_REQUEST('marker');
}